import React, { useState } from 'react';
import { FAQ_ITEMS, GLOSSARY_ITEMS } from '../constants';
import { Plus, Minus } from 'lucide-react';

const InfoSection: React.FC = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="py-24 bg-slate-950 border-t border-slate-900">
      <div className="container mx-auto px-6">
        
        {/* Glossary Section */}
        <div className="mb-32">
          <div className="flex items-center gap-4 mb-12 border-b border-slate-900 pb-6">
             <div className="w-2 h-2 bg-sage-400"></div>
             <h2 className="text-xl font-light text-white tracking-widest uppercase">Glosario Técnico</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-slate-900">
            {GLOSSARY_ITEMS.map((item, idx) => (
              <div key={idx} className="group bg-slate-950 border-r border-b border-slate-900 p-8 hover:bg-slate-925 transition-colors">
                <h3 className="text-sm font-mono font-bold text-sage-400 mb-4 group-hover:text-white transition-colors">
                  {item.term}
                </h3>
                <p className="text-slate-500 text-sm font-light leading-relaxed">
                  {item.definition}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="max-w-4xl mx-auto">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-light text-white mb-2">Preguntas Frecuentes</h2>
            <div className="w-12 h-[1px] bg-sage-400 mx-auto"></div>
          </div>
          
          <div className="border-t border-slate-900">
            {FAQ_ITEMS.map((faq, idx) => (
              <div key={idx} className="border-b border-slate-900 group">
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full flex justify-between items-center py-6 text-left focus:outline-none hover:bg-slate-925 transition-colors px-4"
                >
                  <span className="text-base text-slate-300 font-light group-hover:text-white transition-colors">{faq.question}</span>
                  {openFaq === idx ? (
                    <Minus className="text-sage-400 flex-shrink-0" size={16} />
                  ) : (
                    <Plus className="text-slate-600 flex-shrink-0" size={16} />
                  )}
                </button>
                {openFaq === idx && (
                  <div className="px-4 pb-8 pt-2 text-slate-500 text-sm font-light leading-relaxed animate-fade-in max-w-2xl">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default InfoSection;